module.exports = __webpack_public_path__ + "static/media/backtest.b47c6b76.mp4";